import React from 'react';
import PropTypes from 'prop-types';

const IconWhatsapp = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6212_20671)">
      <path
        d="M0 17.9999L1.29555 13.187C0.250722 11.3122 -0.0812312 9.12434 0.360607 7.02506C0.802445 4.92577 1.98844 3.05582 3.70095 1.75834C5.41346 0.460868 7.53763 -0.177099 9.68365 -0.0384898C11.8297 0.100119 13.8536 1.00601 15.3841 2.51294C16.9145 4.01987 17.8488 6.02677 18.0156 8.16537C18.1823 10.304 17.5702 12.4308 16.2917 14.1556C15.0132 15.8804 13.154 17.0875 11.0552 17.5553C8.95648 18.0232 6.75898 17.7204 4.86597 16.7026L0 17.9999ZM5.1006 14.9015L5.40663 15.0796C6.92658 15.9813 8.72477 16.2972 10.4621 15.9677C12.1995 15.6382 13.7559 14.686 14.838 13.2907C15.92 11.8955 16.4529 10.1536 16.3361 8.39343C16.2194 6.6333 15.461 4.9766 14.2041 3.73573C12.9471 2.49485 11.2785 1.75556 9.51273 1.65726C7.747 1.55896 6.00622 2.10843 4.61864 3.20207C3.23107 4.29571 2.29259 5.85794 1.98017 7.59418C1.66775 9.33042 2.00298 11.1207 2.92264 12.6274L3.11136 12.9377L2.38198 15.624L5.1006 14.9015Z"
        fill="#36B368"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4046 10.1293C12.2282 9.98741 12.0216 9.88752 11.8006 9.83726C11.5796 9.78701 11.3501 9.78772 11.1294 9.83934C10.7979 9.97671 10.5837 10.4956 10.3694 10.7551C10.3243 10.8173 10.2579 10.8609 10.1828 10.8778C10.1076 10.8947 10.0289 10.8836 9.9614 10.8467C8.74762 10.3725 7.73022 9.50293 7.07446 8.3792C7.01853 8.30907 6.99205 8.22004 7.00062 8.13084C7.00918 8.04163 7.05211 7.95923 7.12036 7.90096C7.3593 7.66503 7.53472 7.37281 7.63042 7.05133C7.65167 6.69673 7.57023 6.34351 7.3958 6.03381C7.26095 5.59961 7.00431 5.21298 6.65621 4.91962C6.47667 4.83907 6.2776 4.81207 6.08301 4.84186C5.88843 4.87165 5.70664 4.95696 5.55958 5.08751C5.30428 5.30721 5.10164 5.58124 4.96658 5.88941C4.83152 6.19758 4.76749 6.53205 4.77919 6.86817C4.77998 7.05693 4.80396 7.24488 4.8506 7.42781C4.96904 7.86734 5.15118 8.28725 5.39126 8.67428C5.56448 8.97075 5.75347 9.25776 5.95743 9.53409C6.62027 10.4417 7.45349 11.2123 8.41081 11.8032C8.89121 12.1034 9.40465 12.3475 9.94099 12.5307C10.4981 12.7826 11.1133 12.8793 11.7211 12.8105C12.0674 12.7582 12.3955 12.6218 12.6766 12.4134C12.9576 12.2049 13.183 11.9307 13.3329 11.6149C13.4209 11.4242 13.4477 11.2109 13.4094 11.0044C13.3176 10.5821 12.7514 10.3328 12.4046 10.1293Z"
        fill="#36B368"
      />
    </g>
    <defs>
      <clipPath id="clip0_6212_20671">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

IconWhatsapp.propTypes = {
  size: PropTypes.number,
};

IconWhatsapp.defaultProps = {
  size: 18,
};

export default IconWhatsapp;
